import { render, staticRenderFns } from "./quotation_template_edit.vue?vue&type=template&id=bf5bfad8&scoped=true&"
import script from "./quotation_template_edit.vue?vue&type=script&lang=js&"
export * from "./quotation_template_edit.vue?vue&type=script&lang=js&"
import style0 from "./quotation_template_edit.vue?vue&type=style&index=0&id=bf5bfad8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5bfad8",
  null
  
)

export default component.exports